const { map } = require('lodash');

function createRecipeTile(recipe) {
    return {
        id: recipe.ID,
        type: 'recipe',
        data: { recipe },
    };
}

function createRecipeTiles(recipes) {
    return map(recipes, createRecipeTile);
}

module.exports = {
    createRecipeTile,
    createRecipeTiles,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/recipe-tile-factory.js